/**
 * API Client
 * Axios instance for API calls with automatic auth token injection
 */

import axios from 'axios';
import { getApiBaseUrl } from './urlResolver';
import { firebaseClient } from './firebase/firebase-client';
import { isE2ETestMode } from '../utils/apiMode';

export const apiClient = axios.create({
  baseURL: getApiBaseUrl(),
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
});

// Automatically attach Authorization header to every request.
// The E2E header is set independently of the Firebase token: a Playwright
// run may or may not have a real token, but the serverless auth middleware
// also accepts the `X-E2E-Test: true` header when `_E2E_TEST_MODE=true` is
// set on Cloud Run. The conditional MUST stay so real users never leak the
// header upstream.
apiClient.interceptors.request.use(async (config) => {
  const token = await firebaseClient.getIdToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  if (isE2ETestMode()) {
    config.headers['X-E2E-Test'] = 'true';
  }
  return config;
});
